import { observer } from 'mobx-react-lite';
import React, { SyntheticEvent, useState } from 'react'
import { Card, Header, Icon, Tab, Image, Grid, Button } from 'semantic-ui-react';
import PhotoUploadWidget from '../../app/common/imageUpload/PhotoUploadWidget';
import { Photo } from '../../app/models/photo';
import { UserActivity } from '../../app/models/userActivity';
import { useStore } from '../../app/stores/store';

interface Props {
    profile: UserActivity;
}

function ProfilePhotos(props : Props ) {
    const usStore = useStore();
    const [addPhotoMode, setAddPhotoMode] = useState(false);
    const [target, setTarget] = useState('');

    function handleUploadPhoto(file: Blob) {
        usStore.profileStore.uploadPhoto(file).then(() => {
            setAddPhotoMode(false);
        })
    }

    function handleSetMainPhoto(photo: Photo, event: SyntheticEvent<HTMLButtonElement>) {
        event.currentTarget.disabled = true; //.
        setTarget(event.currentTarget.name);

        //usStore.profileStore.setMainPhoto(photo); 
        usStore.profileStore.setMainPhoto(photo).then(() => {
            //window.location.reload(); // it works
        });
    }

    function handleDeletePhoto(photo: Photo, event: SyntheticEvent<HTMLButtonElement>) {
        event.currentTarget.disabled = true; //.
        setTarget(event.currentTarget.name);
        usStore.profileStore.deletePhoto(photo);
    }

    return (
        <Tab.Pane>
            {/* <Header icon='image' content='Photos' />
            <Card.Group itemsPerRow={5} >
                {props.profile.photos?.map(photo => (
                    <Card key={photo.id}>
                        <Image src={photo.url}  />
                    </Card>
                ))}
            </Card.Group> */}

            <Grid>
                <Grid.Column width='16' >
                    <Header content='Photos' icon='image' floated='left' />
                    {usStore.profileStore.isCurrentUser && (
                        <Button content={addPhotoMode ? 'Cancel' : 'Add Photo' } color={'black'} basic floated='right' onClick={() => setAddPhotoMode(!addPhotoMode)} />
                    )}
                </Grid.Column>
                <Grid.Column width='16' >
                    {addPhotoMode ? (
                        // <p>Photo widget goes here</p>
                        <PhotoUploadWidget uploadPhoto={handleUploadPhoto} isLoading={usStore.profileStore.isUploading} />
                    ) : (
                        <Card.Group itemsPerRow={5} >
                            {props.profile.photos?.map(photo => (
                                <Card key={photo.id}>
                                    <Image src={photo.url}  />
                                    {usStore.profileStore.isCurrentUser && (
                                        <>
                                            <Button.Group fluid width={2} >
                                                <Button 
                                                    content='Set Main' 
                                                    color='teal' 
                                                    basic
                                                    //style={{color: 'white'}} 
                                                    disabled={photo.isMain} 
                                                    onClick={event => handleSetMainPhoto(photo, event)} 
                                                    name={'setMain_' + photo.id} 
                                                    loading={target === 'setMain_' + photo.id && usStore.profileStore.isLoading} 
                                                />
                                                <Button 
                                                    icon='trash' 
                                                    color='red' 
                                                    basic 
                                                    disabled={photo.isMain}
                                                    onClick={(event) => handleDeletePhoto(photo, event)} 
                                                    name={'delete_' + photo.id} 
                                                    loading={target === 'delete_' + photo.id   && usStore.profileStore.isLoading} 
                                                />
                                            </Button.Group>
                                        </>
                                    )}
                                </Card>
                            ))}
                        </Card.Group>
                    )}
                </Grid.Column>
            </Grid>

        </Tab.Pane>
    )
}

export default observer(ProfilePhotos);